import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([actions.MAIL_THREADS_FETCH_SUCCESS], 'threadsIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreads/byPage/reducer.js
 **/